"use client";

import React, { useState, useEffect, useCallback } from "react";
import { Table, Container, Spinner, Alert, Button } from "react-bootstrap";
import CreateLandingCardModal from "./modal"; // Adjust the import path as needed
import ActionButton from "../../components/common/ActionBtn";
import editIcon from "../../assets/images/icons/edit-sm-blue.png";
import CustomPagination from "../../components/common/CustomPagination";
import Switch from "react-switch";
import { PERPAGE_RECORD, showToast } from "../../utils/isValidImage";
import { StatusChangeLandingCardById, deleteLandingCardById, getLandingCard } from "../../api/landing";


const LandingCardsList = () => {
  const [cards, setCards] = useState([]);
  const [cardDetail, setCardDetail] = useState({});
  const [cardId, setCardId] = useState(null);
  const [pagination, setPagination] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this Landing Card?")) {
      try {

        const { data:response } = await deleteLandingCardById(id);
        if (response.message) {
          showToast("Landing Card deleted successfully!",true)
          await fetchCards(pagination.currentPage);
        } else {
          throw new Error(response.message);
        }
      } catch (error) {
        showToast("Failed to delete Landing Card.");
        console.error("Error deleting Landing Card:", error);
      }
    }
  }

  const fetchCards = useCallback(async (page = 1) => {
    setLoading(true);
    setError(null);
    try {
      // Optionally, you can pass a "type" parameter if needed, e.g., '?type=beast_mode'
      const { data } = await getLandingCard({page,limit:PERPAGE_RECORD});
      setCards(data.data);
      setPagination(data.pagination);
    } catch (err) {
      console.error("Error fetching landing cards:", err);
      setError("Failed to fetch landing cards. Please try again later.");
    } finally {
      setLoading(false);
    }
  }, []);

  const toggleStatus = async (plan) => {
    setLoading(true);
    try {
      // Adjust the endpoint as necessary if your POST endpoint differs.
      const { data } =  await StatusChangeLandingCardById(plan?.id);
      //axios.patch(url);

      if(data){
        showToast("Landing card status successfully!", true);
        await fetchCards()
      }
    } catch (err) {
      showToast(err.response?.data?.message || "An error occurred. Please try again.");
      // setError(err.response?.data?.message || "An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }

  }

  const handleEditClick = async (lCardId) => {
    setCardDetail(lCardId);
    setCardId(lCardId?.id)
    handleModalShow()
  };

  useEffect(() => {
    fetchCards().then();
  }, [fetchCards]);

  const handlePageChange = (page) => {
    fetchCards(page).then();
  };

  const handleModalClose = () => setShowModal(false);
  const handleModalShow = () => setShowModal(true);

  const handleLandingCardCreated = () => {
    fetchCards().then();
  };

  if (loading) {
    return (
      <Container className="d-flex justify-content-center align-items-center vh-100">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </Container>
    );
  }

  if (error) {
    return (
      <Container className="mt-5">
        <Alert variant="danger" style={{marginLeft:'160px'}} >
          {error}
          <div className="mt-3" >
            <Button onClick={() => fetchCards()}>Retry</Button>
          </div>
        </Alert>
      </Container>
    );
  }

  return (
    <div className="right-side-wrapper">
      <Container className="mt-4">
        <div className="w-100 d-flex justify-content-between align-items-center">
          <h1 className="mb-4">Landing Cards</h1>
          <Button variant="success" onClick={handleModalShow} className="mb-4">
            Add Landing Card
          </Button>
        </div>
        <Table striped bordered hover responsive>
          <thead>
          <tr>
            <th>ID</th>
            <th>Featured Image</th>
            <th>Title</th>
            <th>Subtitle</th>
            <th>Type</th>
            <th>Status</th>
            <th>Created At</th>
            <th>Edit</th>
            <th>Action</th>
          </tr>
          </thead>
          <tbody>
          {cards.map((card) => (
            <tr key={card.id}>
              <td>{card.id}</td>
              <td>
                <img
                  src={card.featured_image}
                  alt={card.title}
                  style={{ width: "100px", objectFit: "cover" }}
                />
              </td>
              <td>{card.title}</td>
              <td>{card.subtitle}</td>
              <td>{card.type}</td>


              <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "8px",  }}>
                    <span
                      className={`px-2  rounded-lg text-sm ${card.is_active ? "active-btn" : "inactive-btn"}`}
                      style={{ minWidth: "60px", textAlign: "center" }}
                    >
                        {card.is_active ? "Active" : "Inactive"}
                    </span>

                  <Switch
                    onChange={() => toggleStatus(card)}
                    checked={card.is_active}
                    offColor="#ccc"
                    onColor="#4CAF50"
                    uncheckedIcon={false}
                    checkedIcon={false}
                    height={20}
                    width={40}
                  />
                </div>
              </td>

              <td>{new Date(card.created_at).toLocaleDateString()}</td>
              <td><ActionButton
                icon={editIcon}
                onClick={() => handleEditClick(card)}
                altText="Edit"
                className="additional-class"
              />
              </td>
              <td>

                <button
                  className="btn btn-outline-danger btn-sm"
                  onClick={() => handleDelete(card.id)}
                >
                  Delete
                </button>
              </td>

            </tr>
          ))}
          </tbody>
        </Table>
        <CustomPagination pagination={pagination} handlePageChange={handlePageChange} />

      </Container>
      <CreateLandingCardModal
        show={showModal}
        handleClose={handleModalClose}
        onLandingCardCreated={handleLandingCardCreated}
        cardDetail={cardDetail}
        cardId={cardId}
      />
    </div>
  );
};

export default LandingCardsList;
